module.exports = __webpack_public_path__ + "static/img/design-2.951a97b3.png";